<script>
    import { Router, Route, Link, navigate } from "svelte-navigator";
    import { onMount } from "svelte";
    import baseUrl from "../../config/config";
    import qs from "qs";

    let productDetails = {};

    let searchQuery = "";

    let products = [];

    let pagesArray = [];

    const urlParams = new URLSearchParams(window.location.search);

    const getProducts = () => {
        let page = urlParams.get("page");

        if (page == null) {
            page = 1;
        }

        let p = qs.stringify({ page: page, searchQuery: searchQuery });

        jQuery.post(baseUrl + "get-products.php", p, (data) => {
            // console.log(data);
            let d = JSON.parse(data);

            console.log(d);

            productDetails = d.metadata;

            let pages = [];

            // add pages
            for (let x = 0; x < productDetails.totalNumberOfPages; x++) {
                pages.push({ page: x + 1 });
            }

            pagesArray = pages;

            products = d.products;
        });
    };

    onMount(() => {
        getProducts();
    });
</script>

<main>
    <div class="mainContainer">
        <div class="statsGrid ui four column stackable grid">
            <div class="doubling four column row">
                <div class="re column">
                    <Link to="">
                        <div class="statsPanel">
                            <div class="iconContainer">
                                <img
                                    src="/assets/icons/whiskey.png"
                                    alt="products icon"
                                    width="32"
                                    height="32"
                                />
                            </div>

                            <div class="descriptionContainer">
                                <div class="figureContainer">{productDetails.totalProducts}</div>
                                <div class="description">Products</div>
                            </div>
                        </div>
                    </Link>
                </div>

                <div class="re column">
                    <Link to="">
                        <div class="statsPanel">
                            <div class="iconContainer">
                                <img
                                    src="/assets/icons/short-exp.png"
                                    alt="products icon"
                                    width="32"
                                    height="32"
                                />
                            </div>

                            <div class="descriptionContainer">
                                <div class="figureContainer">{productDetails.outOfStock}</div>
                                <div class="description">Out Of Stock</div>
                            </div>
                        </div>
                    </Link>
                </div>

                <div class="re column">
                    <Link to="">
                        <div class="statsPanel">
                            <div class="iconContainer">
                                <img
                                    src="/assets/icons/transfer.png"
                                    alt="products icon"
                                    width="32"
                                    height="32"
                                />
                            </div>

                            <div class="descriptionContainer">
                                <div class="figureContainer">{productDetails.orders}</div>
                                <div class="description">Orders</div>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
        </div>

        <div class="" style="padding-top: 1em;">
            <table class="ui striped inverted basic table">
                <thead>
                    <th> No </th>
                    <th> Image </th>
                    <th> Name </th>
                    <th> Stock </th>
                    <th> Price </th>
                </thead>
                <tbody>
                    {#each products as product}
                        <tr>
                            <td>
                                {product.no}
                            </td>
                            <td>
                                <img
                                    src={baseUrl + product.image}
                                    alt="products icon"
                                    width="32"
                                    height="32"
                                />
                            </td>
                            <td>
                                <Link to={product.slug}>
                                    <div class="">
                                        <span class="productLink">
                                            {product.name}
                                        </span>
                                    </div>
                                </Link>
                                <div class="productActions">
                                    <span style="color: yellow;">
                                        <i class="edit icon" /> Edit
                                    </span>

                                    &nbsp;&nbsp;

                                    <span style="color:red">
                                        <i class="edit icon" /> Edit
                                    </span>
                                </div>
                            </td>
                            <td>
                                {product.stock}
                            </td>
                            <td>
                                <span class="regularPrice">
                                    {product.regularPrice}
                                </span>

                                <span class="salePrice">
                                    {product.salePrice}
                                </span>
                            </td>
                        </tr>
                    {/each}
                </tbody>
            </table>

            <!-- pages -->
            <div class="pages">
                {#each pagesArray as page}
                    <div class="pageNo">
                        <a href={"?page=" + page.page}>
                            {page.page}
                        </a>
                    </div>
                {/each}
            </div>
            <!-- pages -->
        </div>
    </div>
</main>

<style>
    .mainContainer {
        padding: 1em;
    }

    .statsPanel {
        border: 1px solid rgba(128, 128, 128, 0.151);
        padding: 0.4em;
        border-radius: 4px;
        color: aliceblue;
        display: flex;
        flex-direction: row;
        margin-bottom: 10px;
        background: rgb(26, 26, 26);
    }

    .statsPanel:hover {
        background: #52515194;
        border: 1px solid rgba(73, 73, 73, 0.137);
        color: orangered;
    }

    .iconContainer {
        text-align: right;
        flex: 1;
        padding-top: 1em;
    }

    .descriptionContainer {
        flex: 3;
    }

    .figureContainer {
        font-size: 16px;
        text-align: center;
        font-weight: 600;
        padding-top: 5px;
        /* color: rgb(61, 61, 61); */
    }

    .description {
        font-size: 14px;
        text-align: center;
        padding-top: 5px;
        /* color: rgb(47, 47, 48); */
    }

    .statsGrid {
        border-bottom: 1px solid rgba(150, 147, 147, 0.192);
    }

    .productLink {
        font-weight: 600;
        color: dodgerblue;
    }

    .productActions {
        font-size: 11px;
        padding-top: 5px;
    }

    .regularPrice {
        text-decoration: line-through;
    }

    .salePrice {
        font-size: 15px;
    }

    .pageNo {
        display: inline;
        padding-inline: 5px;
    }
</style>
